<template>
  <div>

    <el-button size="mini" type="primary"  @click="plxgzt" style="margin-bottom: 10px">批量修改状态</el-button>

    <el-table
     :data="tableData" 
     border 
     :cell-style="{padding:0,borderColor:'#000000'}"
     :header-cell-style="{borderColor:'#000000',color:'#0099ff'}" 
     style="width: 100%;border: 1px solid #000000" 
     :row-style="{height:'100px'}"
     @selection-change="selectionChange"
     v-loading="loading"
    >

      <!-- 全选按钮 -->
      <el-table-column
        align="center"
        type="selection"
        label="全选"
        width="40px">
      </el-table-column>

      <!-- 站点 -->
      <el-table-column prop="site" label="站点" width="105"> </el-table-column>

      <!-- 订单状态 -->
      <el-table-column prop="status" label="订单状态" width="90">
          <template slot-scope="scope">
              <el-tag
              :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
              disable-transitions>
                {{scope.row.status}}
              </el-tag>
          </template>
      </el-table-column>

      <!-- 订单id -->
      <el-table-column prop="ID_" label="订单ID" width="60px"></el-table-column>

      <!-- 商品id -->
      <!-- <el-table-column prop="product_id" label="商品ID" width="150px"></el-table-column> -->

      <!-- 下单时间 -->
      <el-table-column prop="date_created_gmt" label="下单时间" width="95px"></el-table-column>

      <!-- 付款时间 -->
      <el-table-column prop="date_paid_gmt" label="付款时间" width="95px"></el-table-column>

      <!-- SKU -->
      <!-- <el-table-column prop="sku" label="SKU" width="100px"></el-table-column> -->

      <!-- 国际物流单号 -->
      <el-table-column prop="int_no" label="国际物流单号" width="140px">
      </el-table-column>

      <!-- 图片 -->
      <el-table-column label="图片" width="50px">
        <template slot-scope="scope">
          <el-popover placement="right" width="500" trigger="click">
            <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
            <img :src="scope.row.img" alt="暂无图片" width="30px" height="30px" slot="reference">
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column label="图片" width="120">
          <template slot-scope="scope">
              <img :src="scope.row.img" alt="暂无图片" width="100">
          </template>
      </el-table-column> -->

      <!-- 商品名称 -->
      <el-table-column prop="product_name" label="商品名称" width="150px"></el-table-column>

      <!-- 定制信息 -->
      <el-table-column label="定制信息">
        <template slot-scope="scope">
          <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
          <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
          <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
          <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
        </template>
      </el-table-column>

      <!-- 袖标 -->
      <el-table-column label="袖标" width="125">
        <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
          <span v-for="(item,index) in scope.row.armband" :key="index">
              <el-popover placement="left" trigger="click" width="300">
                <img :src="item" width="100%" style="background:gray" />
                <img
                  slot="reference"
                  :src="item"
                  :alt="123"
                  width="48px" height="48px"
                  style="margin:1px;background:gray"
                />
              </el-popover>
            </span>
        </template>
      </el-table-column>

      <!-- 配件 -->
      <el-table-column label="配件" width="125">
        <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
          <span v-for="(item,index) in scope.row.accessories" :key="index">
              <el-popover placement="left" trigger="click" width="300">
                <img :src="item" width="100%" />
                <img
                  slot="reference"
                  :src="item"
                  :alt="123"
                  width="50px" height="50px"
                />
              </el-popover>
            </span>
        </template>
      </el-table-column>

      <!-- 数量 -->
      <el-table-column prop="quantity" label="数量" width="40px"></el-table-column>

      <!-- 客户备注 -->
      <el-table-column prop="customer_note" label="客户备注" width="100"></el-table-column>

      <!-- 商品备注 -->
      <el-table-column label="商品备注" width="100px">
          <template slot-scope="scope">
                <!-- <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                  <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
                </el-tooltip> -->
                <p style="color:red">{{scope.row.product_note}}</p>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
                </el-tooltip>
              </template>
      </el-table-column>

      <!-- 商品状态 -->
      <el-table-column prop="product_status" label="商品状态" width="130px">
          <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
                  <el-button
                   :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '未提货' ? 'warning' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : (scope.row.product_status === '待处理' ? 'info' : '')))))))))))" 
                   size="mini">
                      {{scope.row.product_status}}
                  </el-button>
                </el-tooltip>
          </template>
      </el-table-column>

      <!-- 价格 -->
      <!-- <el-table-column prop="price" label="价格" width="70px"></el-table-column> -->

      <!-- 物流方式 -->
      <el-table-column prop="shiptype" label="物流方式" width="60px"></el-table-column>

      <!-- 物流商 -->
      <el-table-column prop="wls" label="物流商" width="50px">
      </el-table-column>

      <!-- 定制信息 -->
      <!-- <el-table-column label="定制信息">
            <template slot-scope="scope">
                <div>尺码: {{scope.row.size}}</div>
                <div>袖标：{{scope.row.armband}}</div>
                <div>配件：{{scope.row.accessories}}</div>
                <div>字号：{{scope.row.word_no}}</div>
            </template>
      </el-table-column> -->

      <!-- 是否加急 -->
      <el-table-column :filters="[{text:'是',value:'是'},{text:'否',value:'否'}]" :filter-method="filterHandler" prop='isurgent' label="是否加急" width="55">
        <template slot-scope="scope">
          <span >{{scope.row.isurgent}}</span>
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" width="50px">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.$index, scope.row)"
            circle
          >
          </el-button>
          <el-button
            style="margin-left: 0;margin-top: 10px;"
            type="primary"
            size="mini"
            icon="el-icon-view"
            @click="look(scope.$index, scope.row)"
            circle
          >
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="商品信息" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <!-- <el-form-item label="商品ID" :label-width="formLabelWidth">
            <el-input v-model="form.product_id" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="商品名称" :label-width="formLabelWidth">
            <el-input v-model="form.product_name" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="客服备注" :label-width="formLabelWidth">
            <el-input v-model="form.product_note" autocomplete="off" placeholder="请输入客服备注" disabled></el-input>
            </el-form-item>
            <el-form-item label="仓库备注" :label-width="formLabelWidth">
            <el-input v-model="form.warehouse_note" autocomplete="off" placeholder="请输入仓库备注" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="物流备注" :label-width="formLabelWidth">
            <el-input v-model="form.logistics_note" autocomplete="off" placeholder="请输入物流备注"></el-input>
            </el-form-item>
            <!-- <el-form-item label="国内快递单号" :label-width="formLabelWidth">
            <el-input :disabled="form.product_status == '仓库已发货' ? false : true" v-model="form.inland_number" autocomplete="off" placeholder="请输入国内快递单号"></el-input>
            </el-form-item> -->
            <el-form-item label="商品状态" :label-width="formLabelWidth">
                <el-select v-model="form.product_status" placeholder="请选择商品状态">
                    <el-option label="待审核" value="待审核" disabled></el-option>
                    <el-option label="待发货" value="待发货" disabled></el-option>
                    <el-option label="待发货-制作中" value="待发货-制作中" disabled></el-option>
                    <el-option label="待处理" value="待处理"></el-option>
                    <el-option label="未提货" value="未提货" disabled></el-option>
                    <el-option label="已到货代" value="已到货代"></el-option>
                    <el-option label="物流已发货" value="物流已发货"></el-option>
                    <el-option label="异常" value="异常"></el-option>
                    <el-option label="暂停" value="暂停"></el-option>
                    <el-option label="已取消" value="已取消" disabled></el-option>
                    <el-option label="已退款" value="已退款" disabled></el-option>
                    <el-option label="缺货" value="缺货" disabled></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="国际物流单号" :label-width="formLabelWidth">
              <el-input v-model="form.int_no" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="运输方式" :label-width="formLabelWidth">
              <el-input v-model="form.shiptype" autocomplete="off" disabled></el-input>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
    </el-dialog>

    <el-dialog
      title="修改状态"
      :visible.sync="plxgztdhk"
      width="30%"
      :before-close="handleClose">

      <el-select size="mini" style="margin-left: 10px" v-model="selectProductStatus" placeholder="请选择商品状态">
        <el-option
          v-for="item in ProductStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled">
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="plxgztdhk = false">取 消</el-button>
        <el-button type="primary" @click="qdplxgspzt">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getProduct,Edit,wlplxgspzt } from "../../api/api";
export default {
  data() {
    return {
      tableData: [], //订单列表
      loading: true,
      dialogFormVisible: false,
      form: {
        // product_id: '',
        // product_name: '',
        // product_note: '',
        // warehouse_note: '',
        // logistics_note: '',
        // inland_number: '',
        // product_status: '',
        // int_no:'',
        // shiptype:'',
        // ID_:'',
        // site:'',
        // status:'',
        // date_paid_gmt:''
      },
      formLabelWidth: '120px',

      plxgztdhk: false, //默认 批量修改状态对话框 的 状态
      _arr:[], //默认 选中的订单数组 的值

      ProductStatus:[{ text: '待审核', value: '待审核',disabled: true }, { text: '待发货', value: '待发货',disabled: true }, { text: '待发货-制作中', value: '待发货-制作中',disabled: true }, { text: '待处理', value: '待处理'}, { text: '未提货', value: '未提货',disabled: true }, { text: '已到货代', value: '已到货代' }, { text: '物流已发货', value: '物流已发货' }, { text: '异常', value: '异常' }, { text: '暂停', value: '暂停' }, { text: '已取消', value: '已取消',disabled: true }, { text: '已退款', value: '已退款',disabled: true }, { text: '缺货', value: '缺货',disabled: true }],//商品状态
      selectProductStatus:[],//筛选商品状态

      plxgztArr:[],//批量修改状态时传递给后端参数组成的数组

    };
  },

  created() {
    // var un = window.localStorage.getItem('un');
    // if(un == '' || un == null || un == undefined){
    //   this.loading = true;
    //   this.$message({
    //     message: '账号密码过期，请重新登录！！！',
    //     type: 'error',
    //     duration:5000
    //   });
    //   return false;
    // }

    var id_ = this.$route.query.id;
    getProduct(id_).then((res) => {
      for (const i of res) {
        if(i.armband == null || i.armband == undefined || i.armband == ''){
          i.armband = '无';
        }
        else if(i.armband.charAt(0) == "h"){
          i.armband = i.armband.split(",");
        }

        if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
          i.accessories = '无';
        }
        else if(i.accessories.charAt(0) == "h"){
          i.accessories = i.accessories.split(",");
        }
      }

        // if(i.armband == null || i.armband == ""){
        //   i.armband = "无";
        // }
        // if(i.accessories == null || i.accessories == ""){
        //   i.accessories = "无";
        // }
        // if(i.word_no == null || i.word_no == "" || i.word_no == "null"){
        //   i.word_no = "无";
        // }
        // i.pro_det = `<br/>配件:${i.accessories}<br/>字号:${i.word_no}<br/>尺码:${i.size}<br/>袖标:${i.armband}`;
      
      this.tableData = res;
      this.loading = false;
    });
  },

  methods: {

    // 筛选是否加急
    filterHandler(value, row) {
      if(value === '否'){
        return row.isurgent === '';
      }else{
        return row.isurgent === value;
      }
    },

    // 确定批量修改商品状态
    qdplxgspzt(){
      // debugger

      // var _person = window.localStorage.getItem('un');
      var _person = 'CKWJ';
      var _time = this.$moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss");

      // 点击确定按钮时未选择商品状态
      if(this.selectProductStatus.length == 0){

        this.$message({
          message: '未选择商品状态！！！',
          type: 'warning'
        });

        return false;

      }else{

        for(var i of this._arr){

          // 选择的订单里面的商品状态和要修改的商品状态 相同时
          if(i.product_status == this.selectProductStatus){
            continue
          }

          // 选择的订单里面的商品状态和要修改的商品状态 不同时
          else{
            for(var k of this.tableData){
              if(i.product_id == k.product_id){
                k.product_status = this.selectProductStatus;
              }
            }
            /*

              国际物流单号 int_no
              物流商简码
              订单ID      ID_
              物流方式    shiptype
              站点        site
              付款时间    date_paid_gmt
              订单状态    status

              商品ID      product_id
              商品状态    
              修改时间    time
              操作人      person

            */ 
            
            var a = i.int_no.substring(i.int_no.length - 2);

            // 要修改的商品状态如果是 物流已发货 (必填的参数: 国际物流单号 (物流商简码 === 通过国际物流单号 截取判断后 赋值 物流商简码) 订单ID 物流方式 站点 付款时间 订单状态)
            if(this.selectProductStatus == '物流已发货' && ((i.int_no != '' && i.int_no != null && i.int_no != undefined && i.int_no != '无') && (i.ID_ != '' && i.ID_ != null && i.ID_ != undefined && i.ID_ != '无') && (i.shiptype != '' && i.shiptype != null && i.shiptype != undefined && i.shiptype != '无') && (i.site != '' && i.site != null && i.site != undefined && i.site != '无') && (i.date_paid_gmt != '' && i.date_paid_gmt != null && i.date_paid_gmt != undefined && i.date_paid_gmt != '无') && (i.status != '' && i.status != null && i.status != undefined && i.status != '无') && (i.product_id != '' && i.product_id != null && i.product_id != undefined && i.product_id != '无') && (_time != '' && _time != null && _time != undefined && _time != '无') && (_person != '' && _person != null && _person != undefined && _person != '无') )){

              var _params = {
                int_no:i.int_no,
                wlsjm:a == 'CN' ? 'china-post' : (a == 'DE' ? 'dhl-nl' : (a == 'NL' ? 'postnl-parcels' : (a == 'GB' ? 'royal-mail' : ''))),
                ID_:i.ID_,
                shiptype:i.shiptype,
                site:i.site,
                date_paid_gmt:i.date_paid_gmt,
                status:i.status,
                product_id:i.product_id,
                product_status:this.selectProductStatus,
                time:_time,
                person:_person
              };
              this.plxgztArr.push(_params);

            }

            // 修改商品状态为其他(不是物流已发货)时 (必填的参数: 商品ID 商品状态 修改时间 操作人)
            else if(this.selectProductStatus != '物流已发货' && ((i.product_id != '' && i.product_id != null && i.product_id != undefined && i.product_id != '无') && (_time != '' && _time != null && _time != undefined && _time != '无') && (_person != '' && _person != null && _person != undefined && _person != '无'))){

              var params = {
                product_id:i.product_id,
                product_status:this.selectProductStatus,
                time:_time,
                person:_person
              };
              this.plxgztArr.push(params);

            }

            // 修改商品状态时 缺少必填参数
            else{
              continue
            }
          }
        }
        // console.log(this.plxgztArr);
        this.$message({
          message: '修改成功！！！',
          type: 'success'
        });
      }
      // console.log(this._arr);
      // console.log(this.selectProductStatus);
      wlplxgspzt(this.plxgztArr).then(res => {
        console.log(res);
      })
      this.plxgztdhk = false
    },

    // 批量修改状态按钮
    plxgzt(){
      
      if(this._arr == undefined || this._arr.length == 0){
        this.$message({
          message: '未选择批量修改状态的订单，请先选择！！！',
          type: 'warning'
        });
      }else{
        this.plxgztdhk = true;
      }
    },

    // 关闭(X)批量修改状态对话框
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },

    // 全选按钮
    selectionChange(selection){
      // console.log(selection);
      this._arr = selection;
      // console.log(this._arr);
    },

    //编辑
    edit(index,row){
      // console.log(row);

        // var un = window.localStorage.getItem('un');
        // console.log(un);
        // if(un == '' || un == null || un == undefined){
        //   this.loading = true;
        //   this.$message({
        //     message: '账号密码过期，请重新登录！！！',
        //     type: 'error',
        //     duration:5000
        //   });
        //   return false;
        // }

        this.dialogFormVisible = true;
        this.form = {
            product_id: row.product_id,
            // product_name: row.product_name,
            // product_note: row.product_note,
            // warehouse_note: row.warehouse_note,
            logistics_note: row.logistics_note,
            // inland_number: row.inland_number,
            product_status: row.product_status,
            int_no: row.int_no,
            shiptype: row.shiptype,
            ID_: row.ID_,
            site: row.site,
            status: row.status,
            date_paid_gmt: row.date_paid_gmt
        }
    },

    //取消编辑
    cancel(){
        this.dialogFormVisible = false;
        this.$message('取消编辑成功！！！');
    },

    //确定编辑
    confirm(){
        // console.log(this.form.inland_number);
        // if((this.form.int_no == '' || this.form.int_no == undefined) && this.form.product_status == "物流已发货"){
        if((this.form.int_no == '' || this.form.int_no == undefined) && this.form.product_status == "TMD"){
            this.$message({
                message:'物流已发货时，国际物流单号不能为空！！！',
                type:'error'
            })
            return false;
        }else{
          var timee = new Date();
          var timeee = this.$moment(timee.getTime()).format("YYYY-MM-DD HH:mm:ss");
          var params = {
            product_id: this.form.product_id,
            // product_name: this.form.product_name,
            // product_note:this.form.product_note,
            // warehouse_note:this.form.warehouse_note,
            logistics_note:this.form.logistics_note,
            // inland_number:this.form.inland_number,
            product_status:this.form.product_status,
            int_no:this.form.int_no,
            shiptype:this.form.shiptype,
            ID_:this.form.ID_,
            site:this.form.site,
            status:this.form.status,
            date_paid_gmt:this.form.date_paid_gmt,
            person:'CKWJ',
            time:timeee
          };
          Edit(params).then(res => {
            console.log(res);
            if(res.code === 200){
              this.loading = true;
              for(var i of this.tableData){
                if(i.product_id == this.form.product_id){
                  // i.product_name = this.form.product_name;
                  // i.product_note = this.form.product_note;
                  // i.warehouse_note = this.form.warehouse_note;
                  i.logistics_note = this.form.logistics_note;
                  // i.inland_number = this.form.inland_number;
                  i.product_status = this.form.product_status;
                  // i.int_no = this.form.int_no;
                  // i.shiptype = this.form.shiptype;
                }
              }
              this.loading = false;
              this.$message({
                message: '编辑成功！！！',
                type: 'success'
              });
            }else{
              this.$message({
                message: '编辑失败！！！',
                type: 'error'
              });
            }
          }).catch((error) => {
            console.log(error);
          });
          this.dialogFormVisible = false;
        }
        // // this.reload();
    },

    //查看详情
    look(index, row){
        const routeData = this.$router.resolve({ path: "/home/Orderdetail_", query: { site: row.site, ID_: row.ID_ } });
        window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped></style>
